module.exports = __webpack_public_path__ + "img/Psychology1.cce6883e.png";